// @flow

import { connect } from 'react-redux';
import ScribeTranscript from './ScribeTranscript';
import { scribeSelectTranscriptWord } from '../../actions';

const emptyArray = [];

const mapStateToProps = (state, { id }) => {
  const {
    scribeTranscriptUI: { fontSize, wordBeingEdited },
    scribeConversation: {
      speakers,
      ui: { selectedTranscriptIndex, selectedWordIndex },
      muted,
      lang,
      scribe,
      status,
      listenedTranscriptId,
    },
    scribeSession: {
      activeFeatures,
      currentPlatform,
      socketConnected,
      captioner,
      lightView,
    },
  } = state;

  const {
    [id]: {
      texts,
      highlighted,
      speechLang,
      cursors,
      isFinal,
      mutationsQueuedByHumanMutation,
      indexes,
      author,
      authorShow,
    },
  } = state.scribeConversation.transcripts;
  const cursorsSize = (cursors || [])
    .map(cursor => cursor.index)
    .filter(i => i >= 0).length;
  return {
    activeFeatures,
    author,
    authorShow,
    scribe,
    currentPlatform,
    cursors,
    fontSize,
    highlighted,
    id,
    isFinal,
    isSelected: selectedTranscriptIndex === id,
    lang,
    mutationsQueuedByHumanMutation: mutationsQueuedByHumanMutation.length
      ? mutationsQueuedByHumanMutation
      : emptyArray,
    muted,
    participantsHash:
      status.participants && cursorsSize ? status.participants : undefined,
    selectedWordIndex: selectedTranscriptIndex === id ? selectedWordIndex : 0,
    socketConnected,
    speakers,
    speechLang,
    texts,
    user: captioner,
    lightView,
    wordBeingEdited: selectedTranscriptIndex === id ? wordBeingEdited : false,
    indexes,
    listened: listenedTranscriptId === id,
  };
};

export default connect(
  mapStateToProps,
  { scribeSelectTranscriptWord }
)(ScribeTranscript);
